var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39.2 56.7",
    style: {
      enableBackground: "new 0 0 39.2 56.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2074A4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.2,43.2c-3,2.2-6.8,3.5-10.8,3.5c-10.2,0-18.4-8.3-18.4-18.4c0-10.2,8.3-18.4,18.4-18.4 c4.1,0,7.8,1.3,10.8,3.5V2.2C35.8,0.8,32.2,0,28.3,0C12.7,0,0,12.7,0,28.3C0,44,12.7,56.7,28.3,56.7c3.8,0,7.5-0.8,10.8-2.2V43.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.4,28.3c0-2.4,2-4.4,4.4-4.4c2.4,0,4.4,2,4.4,4.4c0,2.4-2,4.4-4.4,4.4C32.4,32.7,30.4,30.8,30.4,28.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxlogo);
export default __webpack_public_path__ + "static/media/boxlogo.215526cc4ee75fbaae89610c93e96c09.svg";
export { ForwardRef as ReactComponent };